import { Document, Types } from 'mongoose'

export interface Org extends Document {
  installerID: string
  active: boolean
  companyName: string
  apiEnabled?: boolean
  acceptPrescreen?: boolean
  isIntegrator?: boolean
  enabledIntegrations?: string[]
  operatingStates: string[]
  airtableId?: string
  achAccountNo?: string
  achRoutingNo?: string
  achInstitutionName?: string
  achAccountType?: string
  isTeslaCertified: boolean
  isOnHold: boolean
  fundingSchedule: string
  ccefAuthorized: string
  hasValidACHSettings: () => boolean
}

export interface SOrg extends Org {
  _id: Types.ObjectId
}

// obviously needs to be a better place for this
export const isServiceableAddress = (state, country, org) => {
  return country === "United States" && (
    org.operatingStates?.includes(state) ||
    (!org.operatingStates?.length && state === 'FL')
  )
}

export const shouldShowCCEFApplicationPrompt = (org: Org): boolean => {
  return (
    org.ccefAuthorized !== 'Yes' &&
    org.operatingStates?.includes('CO')
  )
}

export const ALLOWED_ORG_UPDATE_FIELDS = [
  'isTeslaCertified',
  'operatingStates',
  'fundingSchedule',
  'apiEnabled',
  'isIntegrator',
  'acceptPrescreen',
  'enabledIntegrations',
  'achInstitutionName',
  'achRoutingNo',
  'achAccountNo',
  'achAccountType',
  'isOnHold',
] as const
